<template>
  <form-section :title="title">
    <template slot="controls">
      <content-actions
        v-model="value"
        :channel="$route.query.channel"
        apply-template-enabled
        copy-enabled
        :model="model"
      />
      <slot name="selected-template-info"></slot>
    </template>
    <el-row>
      <el-col :lg="10" :xl="8">
        <form-item prop="url" :label="$t('CampaignForm_Webhook_Url')">
          <el-input
            v-model="value.webhook.url"
            :placeholder="$t('CampaignForm_Webhook_Url_Placeholder')"
            data-qa="webhook-url-input"
          />
        </form-item>
        <form-item
          prop="add"
          :label="$t('CampaignForm_Webhook_RequestType_Get')"
        >
          <key-value-editor
            v-model="value.webhook.get_params"
            :add-btn-title="$t('CampaignForm_Webhook_Add_Get_Param_Button')"
            data-qa="webhook-add-get-btn"
          />
        </form-item>

        <form-item
          prop="request"
          :label="$t('CampaignForm_Webhook_RequestBody')"
        >
          <el-select
            v-model="value.webhook.request_body_type"
            data-qa="webhook-request-body-dropdown"
          >
            <el-option
              value="raw"
              :label="$t('CampaignForm_Webhook_RequestType_Raw')"
              data-qa="webhook-request-raw"
              >{{ $t('CampaignForm_Webhook_RequestType_Raw') }}</el-option
            >
            <el-option
              value="post"
              :label="$t('CampaignForm_Webhook_RequestType_Post')"
              data-qa="webhook-request-post"
              >{{ $t('CampaignForm_Webhook_RequestType_Post') }}</el-option
            >
            <el-option
              value="json"
              :label="$t('CampaignForm_Webhook_RequestType_Json')"
              data-qa="webhook-request-json"
              >{{ $t('CampaignForm_Webhook_RequestType_Json') }}</el-option
            >
          </el-select>
        </form-item>
        <form-item
          prop="raw"
          :label="$t('CampaignForm_Webhook_RequestType_Raw')"
          v-if="value.webhook.request_body_type === 'raw'"
        >
          <el-input
            type="textarea"
            v-model="value.webhook.request_body_data.raw"
            data-qa="webhook-body-raw"
          />
        </form-item>
        <form-item
          prop="post"
          :label="$t('CampaignForm_Webhook_RequestType_Post')"
          v-if="value.webhook.request_body_type === 'post'"
        >
          <key-value-editor
            v-model="value.webhook.request_body_data.post"
            :add-btn-title="$t('CampaignForm_Webhook_Add_Post_Button')"
            data-qa="webhook-add-post-btn"
          />
        </form-item>
        <form-item
          prop="post"
          :label="$t('CampaignForm_Webhook_RequestType_Json')"
          v-if="value.webhook.request_body_type === 'json'"
        >
          <key-value-editor
            v-model="value.webhook.request_body_data.json"
            :add-btn-title="$t('CampaignForm_Webhook_Add_Json_Button')"
            data-qa="webhook-add-json-btn"
          />
        </form-item>
        <form-item
          prop="request_headers"
          :label="$t('CampaignForm_Webhook_RequestHeaders')"
        >
          <key-value-editor
            v-model="value.webhook.request_headers"
            :add-btn-title="$t('CampaignForm_Webhook_Add_Header_Button')"
            data-qa="webhook-add-header-btn"
          />
        </form-item>
      </el-col>
      <el-col :lg="14" :xl="16" class="preview">
        <webhook-preview :message="messagePreview" />
      </el-col>
    </el-row>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import WebhookPreview from '@/common/components/webhook/WebhookPreview'
import { EventBus } from '@/core/EventBus'
import { channelTypes } from '@/modules/campaign-manage/enum/Labels'
import KeyValueEditor from '@/modules/campaign-manage/components/content/channels/KeyValueEditor'
import FormItem from '@/common/components/form/FormItem'
import ContentActions from '@/modules/campaign-manage/components/ContentActions'

export default {
  name: 'Webhook',
  components: {
    ContentActions,
    KeyValueEditor,
    FormItem,
    WebhookPreview,
    FormSection
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    title: {
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  computed: {
    messagePreview() {
      let message = {}

      message.url = `${this.value.webhook.url ? this.value.webhook.url : ''}${
        this.value.webhook.get_params.length > 0
          ? '?' + this.encodeParams(this.value.webhook.get_params)
          : ''
      }`

      message.headers = $.map(this.value.webhook.request_headers, item => {
        return `${item.key}: ${item.value}`
      }).join('<br>')

      switch (this.value.webhook.request_body_type) {
        case 'raw':
          message.body = this.value.webhook.request_body_data.raw
          break
        case 'json':
          message.body =
            '{' +
            this.value.webhook.request_body_data.json
              .map(item => {
                return `"${item.key}":"${item.value}"`
              })
              .join() +
            '}'
          break
        case 'post':
          message.body = this.encodeParams(
            this.value.webhook.request_body_data.post
          )
          break
      }
      return message
    }
  },
  methods: {
    copyFrom() {
      EventBus.$emit('copyFromDialog', channelTypes.webhook)
    },
    encodeParams(parameters) {
      let params = []
      for (let param in parameters) {
        if (parameters[param].key && parameters[param].value) {
          params.push(`${parameters[param].key}=${parameters[param].value}`)
        }
      }

      return `${params.join('&')}`
    }
  }
}
</script>

<style scoped>
>>> textarea {
  height: 90px;
}
.preview {
  background-color: #f8fafc;
  padding: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/content/channels/Webhook.vue